import React from 'react'
import { createGlobalStyle } from 'styled-components'
import { Grid as GridBase, styled } from '@mui/material'

export const GlobalStyle = createGlobalStyle`
  .highcharts-credits,
  .highcharts-legend-item {
    display: none !important;
  }

  .highcharts-drilldown-data-label span {
    text-decoration: none !important;
  }

  .highcharts-drilldown-data-label div {
    color: ${props => props.theme.palette.brand.white};
    font-weight: 100;
  }
`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Nav = styled('ul')`
  position: relative;
  display: block;
  margin: 0 auto;
  text-align: center;
  padding: 0;
  list-style: none;

  ${props => props.theme.breakpoints.up('sm')} {
    text-align: left;
  }
`

export const NavItem = styled('li')`
  cursor: pointer;
  display: flex;
  float: left;
  margin: 0 0 20px 0;
  position: relative;
  text-align: left;
  width: 50%;

  & div {
    background-color: ${props => props.theme.palette.brand.gray3};

    & svg {
      color: ${props => props.theme.palette.brand.black1};
    }
  }

  &:last-of-type div {
    background-color: ${props => props.theme.palette.brand.primary};

    & svg {
      color: ${props => props.theme.palette.brand.white};
    }
  }

  & .MuiTypography-body2 {
    float: left;
    line-height: 26px;
    position: relative;
    width: calc(100% - 40px);
  }

  ${props => props.theme.breakpoints.up('sm')} {
    display: flex;
    float: none;
    height: 26px;
    margin: 0 0 35px 0;
    width: auto;

    &::after {
      border-left: 1px dotted ${props => props.theme.palette.brand.black1};
      bottom: -30px;
      content: '';
      display: block;
      height: 25px;
      left: 13px;
      position: absolute;
      width: 1px;
    }

    &:last-of-type::after {
      display: none;
    }

    & .MuiTypography-body2 {
      line-height: 18px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`

export const NavIcon = styled('div')`
  border-radius: 100%;
  display: block;
  float: left;
  height: 26px;
  margin: 0 10px 0 0;
  position: relative;
  width: 26px;
`
